import routes from '@/modules/customer/routes'
import store from '@/modules/customer/store'

export default { routes, store }
